import { useSearchParams } from "react-router-dom";
import useMenuTitle from "../hooks/useMenuTitle";

import ActiveFaultsCardStack from "../modules/activeFaults/ActiveFaultsCardStack";
import FilterEdit from "../modules/activeFaults/FilterEdit";
import { useContext } from "react";
import { UserContext } from "../contexts/UserContext";
import MobileActiveFaultsCardStack from "../modules/activeFaults/mobile/MobileActiveFaultsCardStack";

function ActiveFaults() {
  useMenuTitle("Active Faults");

  const { userDetails } = useContext(UserContext);
  const { isMobile } = userDetails;

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");

  return (
    <>
      {isMobile ? (
        <MobileActiveFaultsCardStack />
      ) : page === "area" ? (
        <ActiveFaultsCardStack />
      ) : page === "filter" ? (
        <FilterEdit />
      ) : null}
    </>
  );
}

export default ActiveFaults;
